import { ProductType } from "@/constants/productTypes";
import { ProductCategory, ProductItem, ProductsState, SoftwareItem } from "@/types";

export function emptyProductsState(): ProductsState {
  return {
    drones: emptyProductCategory(ProductType.DRONE),
    centralBodies: emptyProductCategory(ProductType.CENTRAL_BODY),
    accessories: emptyProductCategory(ProductType.PAYLOAD),
    spareParts: emptyProductCategory(ProductType.SPARE_PART),
    software: {
      number: 0,
      size: 0,
      totalPages: 0,
      totalElements: 0,
      items: [] as SoftwareItem[],
      isDisplayed: true,
      areAllItemsFetched: false,
      type: ProductType.SOFTWARE,
    },
  };
}

function emptyProductCategory(type: ProductType): ProductCategory<ProductItem> {
  return {
    number: 0,
    size: 0,
    totalPages: 0,
    totalElements: 0,
    items: [] as ProductItem[],
    isDisplayed: true,
    areAllItemsFetched: false,
    type: type,
  };
}



// WEBPACK FOOTER //
// ./src/store/modules/products/stateFactory.ts